export const KEY_DOWN = 40;
export const KEY_ENTER = 13;
export const KEY_ESC = 27;
export const KEY_FWD_SLASH = 191;
export const KEY_TAB = 9;
export const KEY_UP = 38;
